export default "__VITE_ASSET__Swe9NuzI__"